import {
  yupBoolean,
  yupEnum,
  yupObject,
  yupString,
} from 'shared/utils/YupUtils';
import { InferType } from 'yup';

export type LoadboardSubscriptionSettingsDTO = InferType<
  typeof loadboardSubscriptionSettingsSchema
>;
export const loadboardSubscriptionSettingsSchema = yupObject({
  role: yupEnum(['dispatcher', 'driver'], null).nullable(),
  email: yupString().nullable(),
  phone_number: yupString().nullable(),
  is_phone_valid: yupBoolean(),
  is_phone_blacklisted: yupBoolean(),
  carrier_email: yupString().nullable(),
  carrier_phone_number: yupString().nullable(),
});

export type UserSettingsPhoneState =
  | 'missing'
  | 'invalid'
  | 'blacklisted'
  | 'valid';

export function getPhoneState({
  phone_number,
  is_phone_valid,
  is_phone_blacklisted,
}: LoadboardSubscriptionSettingsDTO): UserSettingsPhoneState {
  return phone_number === ''
    ? 'missing'
    : !is_phone_valid
      ? 'invalid'
      : is_phone_blacklisted
        ? 'blacklisted'
        : 'valid';
}
